import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { JobServicesService } from '../../services/job-services.service';
import { saveAs } from 'file-saver';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { EventServicesService } from 'src/app/services/event-services.service';
import { TalentPoolService } from 'src/app/services/talent-pool.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { candidateStatus} from 'src/app/enum/candidate-status.enum';
import { AppService } from 'src/app/services/app.service';
import { Subject, takeUntil } from 'rxjs';


@Component({
    selector: 'app-talentpool-management',
    templateUrl: './talentpool-management.component.html',
    styleUrls: ['./talentpool-management.component.css'],
    providers: [MessageService],
    standalone: false
})
export class TalentpoolManagementComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  // Array Var
  talentList: Array<any> = [];
  pageLimits: Array<any> = [];
  status: MenuItem[] = [];
  selectedTalent: Array<any> = [];
  talentpoolCol: Array<any> = [];
  invitesCol: Array<any> = [];
  candidatesCol: Array<any> = [];
  _talentpoolCol: Array<any> = [];
  _selectedColumns: any[] = [];
  colsToDownload: Array<any> = [];
  talentOptions: Array<any> = [];
  eventTalent: object = {};
  filteredTalentList: Array<any> = [];
  columnsToSave: Array<any> = [];
  savedColumnSettings: Array<any> = [];
  sourceData: Array<any> = [];
  eventList: Array<any> = [];
  eventDetails: Array<any> = [];
  _eventDetails: Array<any> = [];
  listAllCandidates: Array<any> = [];
  invitedCandidateList: Array<any> = [];
  allCategoryEvents: any;
  sourceTag: Array<string> = [];
  selectedDegree: Array<any> = [];
  selectedBranch: Array<any> = [];
  selectedCollege: Array<any> = [];
  candidateStatus: any = candidateStatus;
  genderList: any = [];
  pwdList: any = [];
  selectedGender: Array<string> = [];
  selectedPwd: Array<string> = [];
  userPrivileges: Set<string> = new Set();
  selectAllColumns: boolean = false;

  //Filtering Array
  checkedColumns: Array<any> = [];
  selectedStatusElements: Array<any> = [];
  selectedJobTypeElements: Array<any> = [];
  selectedDepartmentElements: Array<any> = [];
  selectedUsersList: any = [];
  dates: any = [];
  moveToEvent: any;
  selectedTalentpoolTypeElements: Array<any> = [];
  rangeDates: Date[] = [new Date()];
  dateFormat: any;

  // Boolean Var
  addTalentpoolSlider: boolean = false;
  sendEmailSlider: boolean = false;
  loadingSpinner: boolean = false;
  showFilterSidebar: boolean = false;
  showSettingsSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  displaySaveFilterSettings: boolean = false;
  displaySaveColumnSettings: boolean = false;
  moveToSelected: boolean = false;
  isLoading: boolean = false;
  allCandidateSelected: boolean = false;
  // selectAll: boolean = false;
  skipLimit: boolean = true;
  mapChoice: boolean = false;
  unmapChoice: boolean = false;
  filterLoading: boolean = false;
  filterActive: boolean = false;
  totalSkeleton: boolean = true;

  // Number Var
  first: number = 1;
  last: number = 10;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalLength: number = 0;
  activeTabIndex: number = -1;
  totalPages: number = 1;

  // String var
  statusSelected: string = 'Active';
  eventSearchTerm: string = '';
  columnSearchTerm: string = '';
  filterSearchTerm: string = '';
  downloadSearchTerm: string = '';
  columnFieldId: string = '';
  downloadAs: string = 'excel';
  exportName: string = 'candidateList';
  candidateSearch: string = '';
  order_by: string = 'asc';
  sort_by: string = 'uuid';
  // Add this property to your component class
skeletonData: any[] = Array(10).fill({}).map((_, index) => ({
  id: `skeleton-${index}`,
  uuid: '',
  first_name: '',
  last_name: '',
  email: '',
  mobile_number: '',
  gender: '',
  date_of_birth: '',
  status: '',
  eventCategory: '',
  createdAt: '',
  events: [],
  sourceTag: '',
  current_stage_name: '',
  current_status: '',
  invitedEvents: [],
  firstName: '',
  lastName: '',
  mobileNumber: '',
  sourceType: '',
  sourceName: ''
}));

  privilege: any = {};
  displayCandidateDetails: boolean = false;
  isCandidateInfoView: boolean = false; 
  selectedUser: any = null;

  moveCandidateSlider: boolean = false;

  constructor(
    private jobService: JobServicesService,
    private messageService: MessageService,
    private _router: Router,
    private eventService: EventServicesService,
    private talentPoolService: TalentPoolService,
    private globalService: GlobalServicesService,
    private eventServices: EventServicesService,
    private breadcrumbService: BreadcrumbService,
    private appService: AppService 
  ) {
    this.pageLimits = [10, 25, 50, 100];

    this.candidatesCol = [
      // { index: 1, field: 'id', header: 'Candidate ID' },
      // { index: 2, field: 'name', header: 'Name' },
      { index: 1, field: 'degree_name', header: 'Degree' },
      { index: 2, field: 'degree', header: 'Specialization' },
      { index: 3, field: 'email', header: 'E-mail' },
      { index: 4, field: 'mobile_number', header: 'Phone' },
      { index: 5, field: 'gender', header: 'Gender' },
      { index: 5, field: 'date_of_birth', header: 'Date Of Birth' },
    ]

    this.selectedColumns = [
      // { index: 1, field: 'id', header: 'Candidate ID' },
      // { index: 2, field: 'name', header: 'Name' },
      { index: 2, field: 'degree', header: 'Specialization' },
      { index: 3, field: 'email', header: 'E-mail' },
      { index: 4, field: 'mobile_number', header: 'Phone' },
      { index: 5, field: 'events', header: 'Event Name' },
      { index: 6, field: 'sourceTag', header: 'Source Tag' },
      { index: 7, field: 'status', header: 'Account Status' },
      { index: 8, field: 'createdAt', header: 'Joined Date' }
    ]

    this.invitesCol = [
      { index: 3, field: 'email', header: 'EMAIL' },
      { field: 'firstName', header: 'FIRST NAME' },
      { field: 'lastName', header: 'LAST NAME' },
      { field: 'mobileNumber', header: 'MOBILE NUMBER' },
      { field: 'eventCategory', header: 'EVENT CATEGORY' },
      { field: 'status', header: 'STATUS' },
      { field: 'invitedEvents', header: 'INVITED EVENTS' },
      { field: 'sourceType', header: 'SOURCE TYPE' },
      { field: 'sourceName', header: 'SOURCE NAME' },
    ]

    this.genderList = [
      {
        "label": "Male",
        "value": "male"
      },
      {
        "label": "Female",
        "value": "female"
      },
      {
        "label": "Prefer not to say",
        "value": "others"
      }
    ]

    this.pwdList = [
      {
        "label": "Yes",
        "value": "Yes"
      },
      {
        "label": "No",
        "value": "No"
      },
      {
        "label": "Do not wish to disclose",
        "value": "Do not wish to disclose"
      },
      {
        "label": "Not yet filled",
        "value": "Not Yet Filled"
      }
    ]
  }

  searchForm = [
    { name: 'Name', value: '' },
    { name: 'Email', value: '' },
    { name: 'Contact Number', value: '' },
    { name: 'Event Name', value: '' },
    { name: 'Source', value: '' },
    { name: 'Account Status', value: 'All' },
    { name: 'Joined Date', value: '' },
    { name: 'Candidate ID', value: '' }
  ]

  columnSettings: FormGroup = new FormGroup({
    name: new FormControl(''),
    saved_columns: new FormControl(this.columnsToSave)
  })

  ngOnInit(): void {
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    if (this.userPrivileges.has('candidate.view')) {
      this.getAllCandidates();
    }
    this.talentpoolCol = this.candidatesCol;
    this._selectedColumns = this.candidatesCol.filter((col: any) => col.field !== 'degree_name');
    this._talentpoolCol = this.talentpoolCol;
    this.colsToDownload = this.talentpoolCol;
    this.checkedColumns = this._selectedColumns;
    this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
    // this.getEvent();
    this.allCandidateSelected = false;
    this.privilege = this.globalService.privilegeDetails;
    this.updateBreadcrumb();
    this.globalService.searchCandidateList.subscribe((response) => {
      this.pageNumber = 1;
      this.talentList = [];
      this.talentList = response ? response.items : [];
      this.talentList.forEach((eachData: any) => {
        eachData.id = eachData.uuid;
      });
      this.totalLength = response.total || 0;
      this.first = response.page || 1;
      this.last = response.pages || 10;
      this.pageSize = response.size || 10;
      this.totalPages = response.pages || 1;
      this.loadingSpinner = false;
    })

    try {
      this.appService.spotlightSearchCandidate.pipe(takeUntil(this.unsub$)).subscribe((spotlightSearchCandidate) => {
        if(spotlightSearchCandidate) {
          this.appService.spotlightSearchCandidate.next(null);
          this.openCandidates(spotlightSearchCandidate)
        }
      });
    } catch(err) {
      console.log("Error while spotlight candidate select")
    }
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  updateBreadcrumb(): void {
    this.breadcrumbService.set('@candidate', 'Manage Candidate');
  }
  

  allSelected() {
    this.allCandidateSelected = true;
  }


  // API functions
  // get all the jobs
  getAllCandidates = () => {
    this.loadingSpinner = true;
    this.globalService.pageNumber = this.pageNumber;
    this.globalService.pageSize = this.pageSize;
    let searchTerm = this.globalService.searchTerm;
    let searchedEmail = searchTerm.trim().split(/\s+/);
    searchTerm = '';
    if (searchedEmail && searchedEmail.length === 1) {
      searchTerm = searchedEmail[0];
    } else if(searchedEmail.length > 0) {
      searchTerm = searchedEmail.join(' ');
    }
      this.talentPoolService
      .getAllCandidatesFastApi(this.pageNumber, this.pageSize, this.order_by, this.sort_by, searchTerm || undefined)
      .subscribe({
        next: (response: any) => {
          if (response.status == 200) {
            this.talentList = response.body ? response.body.items : [];
            this.talentList.forEach((eachData: any) => {
              eachData.id = eachData.uuid;
            });
            this.totalLength = response.body.total || 0;
            this.first = response.body.page || 1;
            this.last = response.body.pages || 10;
            this.pageSize = response.body.size || 10;
            this.totalPages = response.body.pages || 1;
            this.loadingSpinner = false;
          }
        },
        error: () => {
          this.totalLength =  0;
          this.first =  1;
          this.last =  10;
          this.pageSize =  10;
          this.loadingSpinner = false;
        }
      });
    // }
  }

  saveColumnSettings = () => {
    this.loadingSpinner = true;
    this.columnsToSave = this.checkedColumnsBackup.map(e => e.field);

    this.columnSettings.setValue({
      name: this.columnSettings.get("name")?.value,
      saved_columns: this.columnsToSave
    });

    this.eventServices.saveUserPreferencesFastApi(this.columnSettings.value, 'candidate').subscribe({
      next: (result: any) => {
        this.getSavedColumns();
        this.loadingSpinner = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: result.body.detail,
        });
        this.clearColumnPreferenceName();
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
    this.clearColumnPreferenceName();
  }

  event(i: number) {
    this.searchForm.forEach((item, idx) => {
      if (idx != i && item.name != 'Account Status') {
        item.value = ''
      }
    })
  }

  getSavedColumns = () => {
    this.eventServices.getUserPreferencesFastApi('candidate').subscribe(res => {
      this.savedColumnSettings = res.body.user_preferences ? res.body.user_preferences : []
    });
}

deleteSavedColumns = (columnId: string) => {
  this.loadingSpinner = true;
  this.eventServices.deleteUserPreferencesFastApi(columnId).subscribe({
    next: res => {
    this.getSavedColumns();
    this.loadingSpinner = false;
  },
  error: () => {
    this.loadingSpinner = false; 
  }
});
}

  // Normal Functions
  setStatus = (status: string) => {
    this.statusSelected = status;
  }

  getEventVal = (event: Event) => {
    return (event.target as HTMLInputElement).value;
  }

  onSelectedTalentChange = (value: []) => {
    this.selectedTalent = value;

    if (this.selectedUsersList.length == this.pageSize) {
      this.allCandidateSelected = true;
    } else {
      this.allCandidateSelected = false;
    }
    // console.log(this.selectedUsersList);

  }

  applySelectedColumns = () => {
    this.checkedColumns = this.checkedColumnsBackup;
    this._selectedColumns = this.sortedColumns();
    this.showSettingsSidebar = false;
  }

  clearSelectedColumns = () => {
    this.checkedColumns = [
      { index: 1, field: 'id', header: 'CANDIDATE ID' },
      { index: 2, field: 'name', header: 'NAME' },
      { index: 3, field: 'email', header: 'EMAIL' }
    ];
  }

  clearSelectedFilters = () => {
    this.selectedStatusElements = [];
    this.selectedTalentpoolTypeElements = [];
    this.selectedDepartmentElements = [];
    this.rangeDates = [new Date()];
    this.sourceTag = [];
    this.selectedDegree = [];
    this.selectedBranch = [];
    this.selectedCollege = [];
    this.selectedGender = [];
    this.selectedPwd = [];
    this.mapChoice = false;
    this.unmapChoice = false;
    this.filterLoading = false;
    this.filterActive = false;
    this.getAllCandidates();
    // this.getCandidateCount();
  }

  applySavedSettings = (savedColumnValue: Array<any>) => {
    this.checkedColumnsBackup = this.talentpoolCol.filter(e => savedColumnValue.includes(e.field));
    this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
  }

  openCandidates(candidate: any) {
    this.selectedUser = candidate;
    this.displayCandidateDetails = true;
    this.isCandidateInfoView = false; 
}
switchToCandidateInfo(user: any) {
  this.selectedUser = user;
    this.isCandidateInfoView = true; 
  }

  onBackToCandidateBasicInfo() {
    this.isCandidateInfoView = false;
  }


  searchColumns = (searchTerm: string) => {
    if (this.showSettingsSidebar) {
      this._talentpoolCol = this.talentpoolCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    if (this.showDownloadSidebar) {
      this.colsToDownload = this.talentpoolCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  }

  eventSearch(event: any) {
    if (event) {
      this._eventDetails = this.eventDetails.filter(val => val.name.toLowerCase().includes(event.toLowerCase()));
    } else {
      this._eventDetails = this.eventDetails;
    }

  }

  // get jobs by filter
  getTalentByFilter = (status: string) => {
    this.statusSelected = status;
    this.pageNumber = 1;
    this.first = 1;
    this.last = this.pageSize < this.totalLength ? this.pageSize : this.totalLength;
    this.getAllCandidates();
  };

  private sortedColumns(): any[] {
    return this.checkedColumns.sort((a, b) => (a.index < b.index) ? -1 : 1);
  }

  next(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedUsersList = [];
    this.first = this.first + this.pageSize;
    this.last = this.last + this.pageSize < this.totalLength ? this.pageSize + this.last : this.totalLength;
    this.pageNumber += 1;
    this.getAllCandidates();
  }

  prev(): void {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.selectedUsersList = [];
    this.first = this.first - this.pageSize;
    this.last = this.last - this.pageSize > this.pageSize ? (this.last == this.totalLength ? this.totalLength - this.talentList.length : this.last - this.pageSize) : this.pageSize;
    this.pageNumber -= 1;
    this.getAllCandidates();
  }

  isLastPage(): boolean {
    return this.pageNumber === this.totalPages;; 
  }

  isFirstPage(): boolean {
    return this.first === 1;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.talentpoolCol.filter(col => val.includes(col));
  }

  getHeaderVal(col: string) {
    let result = col.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  setEventTalentId(talent: any) {
    this.eventTalent = talent;
  }

  exportRole = (type: string) => {
    let checkedColumnFields: any = ['id','first_name','last_name'];  
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each.field);
    });
    let afterFilter: any = [];
    let candidatesToExport = this.selectedTalent.length > 0 ? this.selectedTalent : this.talentList;
    candidatesToExport.forEach((eachData) => {
      let filterData: any = {};
      checkedColumnFields.forEach((item: any) => {
        eachData.hasOwnProperty(item) && (filterData[item] = eachData[item]);
        switch (item) {
          case "eventDetails":
            let eventName = this.fetchEventDetails(eachData["eventDetails"]);
            filterData[item] = eventName.join(',');
            break;
          case "specialization":
            filterData[item] = eachData["degreeDetails"][0]["degreeBranch"];
            break;
          case "degree_name":
            filterData[item] = this.getDegreeInfo(eachData);
            break;
        }
      });
      afterFilter.push(filterData);
    });
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(afterFilter);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: type === 'Excel' ? 'xlsx' : 'csv',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, this.exportName, type);
    });
  };

  fetchEventDetails = (eventDets: any) => {
    let eventNameArray: any = [];
    eventDets.forEach((item: any) => {
      eventNameArray.push(item.eventTitle)
    });
    return eventNameArray;
  }

  saveAsExcelFile(buffer: any, fileName: string, type: string): void {
    let FILE_TYPE = type === 'Excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' : 'text/csv';
    let FILE_EXTENSION = type === 'Excel' ? '.xlsx' : '.csv';
    const data: Blob = new Blob([buffer], {
      type: FILE_TYPE,
    });
    saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + FILE_EXTENSION
    );
    this.showDownloadSidebar = false;
    this.resetCheckedColumnsToDefault();
  }

  sendEmail() {
    this.sendEmailSlider = true;
  }

  mailSent(event: boolean) {
    this.sendEmailSlider = false;
    if (event) {
      this.selectedUsersList = [];
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Mail Sent!' });
    }
  }
  getAllEventName() {
    this.moveToSelected = true;
    this.talentPoolService.getCategoryWiseEventsFastApi('3').subscribe({
      next: (res: any) => {
        const eventList = res.body;
        this.eventDetails = eventList.map((element: any) => ({
          name: element.name,
          value: element.uuid,
        }));
        this._eventDetails = this.eventDetails;
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  }
  getEventName(eventId: string): string {
    let eventName = '';
    this.allCategoryEvents.forEach((item: any) => {
      if (item.eventId == eventId) {
        eventName = item.eventTitle;
      }
    });
    return eventName;
  }

  getAllCategoryEvents = async () => {
    let techEvents = [];
    let nonTechEvents = [];

    let getTechEvents = () => {
      return new Promise((resolve, rejects) => {
        this.talentPoolService.getAllEventsByCategory('technical').subscribe(res => {
          techEvents = res?.body?.items ?? res?.body ?? res?.data ?? [];
          return resolve(techEvents)
        })
      })
    }
    let getNonTechEvents = () => {
      return new Promise((resolve, rejects) => {
        this.talentPoolService.getAllEventsByCategory('nonTechnical').subscribe(res => {
          nonTechEvents = res?.body?.items ?? res?.body ?? res?.data ?? [];
          return resolve(nonTechEvents);
        })
      })
    }

    this.allCategoryEvents = (await Promise.all([getTechEvents(), getNonTechEvents()])).flat();
  }

  inviteSent(message: any) {
    this.addTalentpoolSlider = false;
    this.messageService.add({ severity: message.severity, summary: message.summary, detail: message.detail })
  }
  bulkInviteSent(message: any) {
    this.addTalentpoolSlider = false;
    this.messageService.add({ severity: message.severity, summary: message.summary, detail: message.detail })
  }

  candidateMoved(message: any) {
    this.moveCandidateSlider = false;
    this.messageService.add({ severity: message.severity, summary: message.summary, detail: message.detail });
    this.selectedUsersList = [];
    this.getAllCandidates();
  }

  onCloseMoveCandidate(event: any) {
    this.moveCandidateSlider = false;
  }

  filterHide() {
    this.filterLoading = false;
    this.showFilterSidebar = false;
    this.activeTabIndex = 1;
  }

  filterShow() {
    this.activeTabIndex = -1;
  }

  printDate() {
    // console.log(this.rangeDates);
  }
  onClickSettingsSidebar(): void {
    this.showSettingsSidebar = true;
    this.showFilterSidebar = false;
    this.showDownloadSidebar = false;
    this.getSavedColumns();
  }

  moveCandidates() {
    this.moveCandidateSlider = true;
  }
hasValidPhoto(candidate: any): boolean {
  return candidate?.photo && 
         candidate.photo.trim() !== '' && 
         candidate.photo !== 'null' && 
         candidate.photo !== null;
}

onImageError(event: any, candidate: any): void {
  event.target.style.display = 'none';
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'flex';
  }  
  candidate._photoError = true;
}

onImageLoad(event: any): void {
  event.target.style.display = 'block';
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'none';
  }
}

getFullName(candidate: any): string {
  const firstName = candidate?.first_name || '';
  const lastName = candidate?.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  
  if (!fullName && candidate?.email) {
    return candidate.email.split('@')[0];
  }
  
  return fullName || 'Unknown';
}

getDegreeInfo(candidate: any): string {
  if (!candidate) return '-';
  const degrees = candidate.degrees || {};
  for (const level of ['ug', 'pg', 'diploma']) {
    if (degrees[level]) {
      return this.formatEducation(degrees[level]);
    }
  }
  
  return '-';
}

getEducationInfo(candidate: any): string {
  if (!candidate) return '-';
  const specializations = candidate.specializations || {};
  const educationLevels = ['ug', 'pg', 'diploma'];
  for (const level of educationLevels) {
    const specialization = specializations[level];
    if (specialization) {
      return this.formatEducation(specialization);
    }
  }
  if (candidate.degree) {
    return candidate.degree;
  }
  
  return '-';
}
private formatEducation(education: string): string {
  if (!education) return '-';

  if (!/^[a-z0-9_ ]+$/.test(education)) {
    return education;
  }

  return education
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
getInitials(fullName: string): string {
  if (!fullName) return 'UN';
  
  const names = fullName.trim().split(' ');
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  
  const firstInitial = names[0].charAt(0).toUpperCase();
  const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
  return firstInitial + lastInitial;
}

getAvatarColor(name: string): string {
  const colors = [
    '#FF6B35', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57', 
    '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43',
    '#EE5A24', '#009432', '#0652DD', '#9980FA', '#833471',
    '#F79F1F', '#A3CB38', '#1289A7', '#D63031', '#74B9FF'
  ];
  
  if (!name) return colors[0];
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
}

getTruncatedId(fullId: string): string {
  if (!fullId) return '';
  
  if (fullId.length <= 13) {
    return fullId;
  }
  
  return fullId.substring(0, 13) + '...';
}

copyToClipboard(text: string, label: string): void {
  if (!text) return;
  
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text.toString()).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    }).catch((err) => {
      console.error('Clipboard API failed:', err);
      this.fallbackCopyToClipboard(text.toString(), label);
    });
  } else {
    this.fallbackCopyToClipboard(text.toString(), label);
  }
}

private fallbackCopyToClipboard(text: string, label: string): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    }
  } catch (err) {
    console.error('Fallback copy failed:', err);
  } finally {
    document.body.removeChild(textArea);
  }
}

getStatusClass(status: string): string {
  if (!status) return 'status-default';
  
  const statusMap: { [key: string]: string } = {
    'active': 'status-active',
    'invited': 'status-invited',
    'inactive': 'status-inactive'
  };
  
  const normalizedStatus = status.toLowerCase().trim();
  return statusMap[normalizedStatus] || 'status-default';
}

toggleSelectAll() {
  if (this.selectAllColumns) {
    this.checkedColumns = [...this.colsToDownload];
  } else {
    this.checkedColumns = [];
  }
}

onColumnCheckChange() {
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}
clearColumnPreferenceName(): void {
  this.columnSettings.get('name')?.setValue('');
  this.displaySaveColumnSettings = false;
}

resetCheckedColumnsToDefault(): void {
  this.checkedColumns = [...this._selectedColumns];
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}

checkedColumnsFields: string[] = [];
checkedColumnsBackup: any[] = [];
updatedSelectedColFields() {
  this.checkedColumnsBackup = JSON.parse(JSON.stringify(this.checkedColumns));
  this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
}

updateCheckedColumns(event: any) {
  this.checkedColumnsFields = event;
  this.checkedColumnsBackup = this._talentpoolCol.filter((col) => event.includes(col.field))
}
}
